import React, { useEffect, useState, useRef } from 'react';
import { DynamicProp } from 'veronica-ui-component/dist/common/commonInterface';
import { StyledDiv, StyledIcon, StyledChildren, StyledButton, StyledTime, StyledBox, StyledCross } from 'veronica-ui-component/dist/component/core/styled/NotificationBar.styled';
//import { DynamicProp } from '../../../common/commonInterface';

export interface BarProps extends DynamicProp {
  background?: string | 'Alert Red' | 'Warning Sunset Orange' | 'Success Aqua Green',
  width?: number | string,
  height?: number | string,
  text?: string,
  id?: string | 'notificationBar',
  disable?: boolean,
  timer?: number,
  onClear?: () => void,
}

const NbisNotificationBar: React.FC<BarProps> = ({
  height = '150px',
  text = 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Enim, nihil rem!',
  background = 'Alert Red',
  id = 'notificationBar',
  disable = false,
  timer = 20,
  width = '150px',
  onClear,
  ...rest
}): any => {

  // Use a ref to track the current text for detecting changes
  const prevTextRef = useRef<string | undefined>(text);

  // Core states
  const [visible, setVisible] = useState(true);
  const [counter, setCounter] = useState(timer);
  const [currentText, setCurrentText] = useState(text);

  // When text prop changes (new message arrives), reset all states
  useEffect(() => {
    if (text !== prevTextRef.current) {
      // This is a new message, completely reset states
      setVisible(true);
      setCounter(timer);
      setCurrentText(text);
      prevTextRef.current = text;
    }
  }, [text, timer]);

  // Timer logic
  useEffect(() => {
    // Don't start timer if not visible
    if (!visible) return;

    // Set up timer
    const interval = setInterval(() => {
      setCounter(prev => {
        const newCount = prev - 1;

        // Trigger close when timer reaches zero
        if (newCount <= 0) {
          clearInterval(interval);
          setVisible(false);
          if (onClear) {
            onClear();
          }
          return 0;
        }
        return newCount;
      });
    }, 1000);

    // Cleanup function
    return () => {
      clearInterval(interval);
    };
  }, [visible, onClear]);

  // Handle manual close
  const handleClose = () => {
    setVisible(false);
    if (onClear) {
      onClear();
    }
  };

  // Render logic
  if (!visible || counter <= 0) {
    return null;
  }

  return (
    <StyledDiv id={id} width={width} height={height} background={background} {...rest}>
      <StyledIcon />
      <StyledChildren> {currentText} </StyledChildren>
      <StyledBox>
        {!disable && <StyledTime>{counter}s</StyledTime>}
        <StyledButton onClick={handleClose}>
          <StyledCross />
        </StyledButton>
      </StyledBox>
    </StyledDiv>
  );
};

export { NbisNotificationBar };